__webpack_require__.p = "https://matchcenter-api.24media.gr/widget/41980de1a410f829bb4e/";